var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Books (source)",
        "class-card": "col-md-4",
        "selected-filter": _vm.selectedFilter,
        filters: _vm.filters
      },
      on: { "set-filter": _vm.setFilter }
    },
    [
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.loading
            ? _c("Loader")
            : _vm.sources && _vm.sources.length > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center flex-wrap"
                  },
                  [
                    _c(
                      "div",
                      {},
                      [
                        _c("BooksSourceChart", {
                          attrs: { sources: _vm.sources }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _c("div", [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v("There are no jobs.")
                  ])
                ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-755575e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755575e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/BooksSource.vue
// module id = null
// module chunks = 